














import { Component, Vue, Prop } from "vue-property-decorator";
import { SelectItem } from "@/typescript/pages/dashboard/index.ts";
export { SelectItem };

@Component
export default class DisplayFilterMenuComponent extends Vue {
  @Prop({
    default: []
  })
  items!: SelectItem[];

  @Prop()
  name!: string;

  @Prop()
  label!: string;

  @Prop()
  menuType!: string;
}
